// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xf5wOo {
  max-width: 600px !important;
  width: 100%;
}

.gp4BgV {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
}

.Rq6pq1 {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 14px);
  line-height: 21px;
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  white-space: pre-line;
}

.WsYIYo {
  display: flex;
  justify-content: center;
  width: 100%;
}

.mOdd9k {
  width: 100%;
}

@media (max-width: 768px) {
  .Xf5wOo {
    max-width: 90vw;
    min-width: unset;
    margin: var(--spacing-2, 16px);
  }

  .WsYIYo {
    justify-content: center;
  }

  .mOdd9k {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixUnderReviewModal/PixUnderReviewModal.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,iBAAiB;EACjB,wCAAwC;EACxC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".pixUnderReviewModal {\n  max-width: 600px !important;\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n}\n\n.description {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 14px);\n  line-height: 21px;\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  white-space: pre-line;\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.confirmButton {\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .pixUnderReviewModal {\n    max-width: 90vw;\n    min-width: unset;\n    margin: var(--spacing-2, 16px);\n  }\n\n  .actions {\n    justify-content: center;\n  }\n\n  .confirmButton {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pixUnderReviewModal": `Xf5wOo`,
	"content": `gp4BgV`,
	"description": `Rq6pq1`,
	"actions": `WsYIYo`,
	"confirmButton": `mOdd9k`
};
module.exports = ___CSS_LOADER_EXPORT___;
